<template>
  <SecondaryVaccinationPage
    title="Traveling"
    :vaccines="vaccinesList"
    prevRoute="/TravelingPage"
    nextRoute="/vaccination"
    :secondaryImage="require('@/assets/page26/Asset 257.png')"
    :footerBanner1="require('@/assets/page26/Asset 261.png')"
    :footerBanner2="require('@/assets/page4/lowererPanner.png')"
  />
</template>

<script setup>
import SecondaryVaccinationPage from "@/components/SecondaryVaccinationPage.vue";

const vaccinesList = [
  {
    imgPath: require("@/assets/page25/Asset 244.png"),
    name: "Influenza",
    ModalData: {
      Indications: {
        text: "All persons ≥6 months",
        img: require("@/assets/page26/Asset 258.png"),
      },
      Administration: {
        text: "One dose every year, preferred before the winter season",
        img: require("@/assets/page26/Asset 259.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction.</br>
        Precautions: Moderate or severe acute illness with or without fever`,
        img: require("@/assets/page26/Asset 260.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page25/Asset 258.png"),
    name: "Typhoid",
    ModalData: {
      Indications: {
        text: `Travelers to areas where there is a recognized risk for exposure to Salmonella serotype Typhi. Risk is greatest for travelers who have prolonged exposure to possibly contaminated foods and beverages, although short-term travelers are also at risk. Travelers should be cautioned that typhoid vaccination is not a substitute for careful selection of food and beverages. 

Parenteral Vi polysaccharide and oral Ty21a are both acceptable forms of typhoid vaccine.
`,
        img: require("@/assets/page26/Asset 258.png"),
      },
      Administration: {
        text: `The Vi polysaccharide vaccine is administered as a single injection and is approved for adults and children aged ≥2 years. Primary vaccination with Vi polysaccharide consists of one 0.5-mL (25-µg) dose administered intramuscularly. This vaccine should be given at least 2 weeks before potential exposure.

The oral Ty21a vaccine is administered in 4 doses on alternating days over 1 week and is approved for adults and children aged ≥6 years. Immunocompromised persons should not use Ty21a because it is a live-attenuated vaccine. Because antibacterial drugs might be active against the vaccine strain and reduce immunogenicity, the Ty21a vaccine should not be administered to persons taking these medications.
Primary vaccination with live-attenuated Ty21a vaccine consists of one enteric-coated capsule taken on alternate days (day 0, 2, 4, and 6), for a total of four capsules. The capsules must be kept refrigerated (not frozen). Each capsule should be taken with cool water no warmer than 37.0°C, approximately 1 hour before a meal. All doses should be completed at least 1 week before potential exposure.

Repeat Doses
If continued or repeated exposure to Salmonella serotype Typhi is expected, repeat doses of typhoid vaccine are needed to maintain immunity. An optimal revaccination schedule for the Vi polysaccharide vaccine has not been established; however, the manufacturer recommends a repeat dose every 2 years after the primary dose if continued or renewed exposure is expected. The manufacturer of Ty21a recommends revaccination with the entire 4-dose series every 5 years if continued or renewed exposure to Salmonella serotype Typhi is expected`,
        img: require("@/assets/page26/Asset 259.png"),
      },
      Contraindications: {
        text: `No data have been reported on the use of either typhoid vaccine in pregnant women. In general, live vaccines like Ty21a are contraindicated in pregnancy. Vi polysaccharide vaccine should be given to pregnant women only if clearly needed. 
`,
        img: require("@/assets/page26/Asset 260.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page25/Asset 249.png"),
    name: "RSV",
    ModalData: {
      Indications: {
        text: "Adults ≥60 years (IM)",
        img: require("@/assets/page26/Asset 258.png"),
      },
      Administration: {
        text: "1 dose",
        img: require("@/assets/page26/Asset 259.png"),
      },
      Contraindications: {
        text: "Patients with a known allergy to components of the vaccine.",
        img: require("@/assets/page26/Asset 260.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page25/Asset 247.png"),
    name: "COVID-19",
    ModalData: {
      Indications: {
        text: `Individuals 12 years and above regardless of previous vaccination. A priority to people with any of the following conditions:<br />
Age over 50 years.<br />
Pregnant women.<br />
Chronic heart, lung, kidney, neurological diseases.<br />
Hereditary blood disorders (sickle cell anemia, thalassemia).<br />
Immunocompromised conditions.<br />
Travelers for Umrah and Hajj.<br />
Healthcare workers with direct patient contact.
`,
        img: require("@/assets/page26/Asset 258.png"),
      },
      Administration: {
        text: `1 dose intramuscular, 3 months after the most recent dose.`,
        img: require("@/assets/page26/Asset 259.png"),
      },
      Contraindications: {
        text: "Patients with a known allergy to components of the vaccine.",
        img: require("@/assets/page26/Asset 260.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page25/Asset 261.png"),
    name: "Zoster",
    ModalData: {
      Indications: {
        text: "Shingrix (RZV) for adults ≥50 years (IM)",
        img: require("@/assets/page26/Asset 258.png"),
      },
      Administration: {
        text: "2 doses - Shingrix (RZV) 2nd dose, 2-6 months apart.",
        img: require("@/assets/page26/Asset 259.png"),
      },
      Contraindications: {
        text: "Patients with a known allergy to components of the vaccine.",
        img: require("@/assets/page26/Asset 260.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page25/Asset 259.png"),
    name: "MMR",
    ModalData: {
      Indications: {
        text: `Individuals at higher risk of either exposure or morbidity e.g., Healthcare personnel, college students, Military personnel, international travelers, etc.`,
        img: require("@/assets/page26/Asset 258.png"),
      },
      Administration: {
        text: `Individuals at high risk should have two doses separated by at least one month or serologic evidence of immunity.`,
        img: require("@/assets/page26/Asset 259.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction, Pregnancy, Immunocompromising conditions`,
        img: require("@/assets/page26/Asset 260.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page25/Asset 260.png"),
    name: "Varicella",
    ModalData: {
      Indications: {
        text: `All adults without evidence of immunity to varicella`,
        img: require("@/assets/page26/Asset 258.png"),
      },
      Administration: {
        text: `2 doses, 2nd dose is given 4—8wks after 1st dose. If 2nd dose is delayed, do not repeat 1st dose, just give 2nd dose.`,
        img: require("@/assets/page26/Asset 259.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction, Pregnancy, Long-term immunosuppressive therapy. </br>
        Precautions: Moderate or severe acute illness.`,
        img: require("@/assets/page26/Asset 260.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page25/Asset 248.png"),
    name: "Tetanus",
    ModalData: {
      Indications: {
        text: `Tdap/Td booster dose every 10 years is recommended for all adult populations. <br />
Tdap is preferred over Td for all booster doses, given the additional coverage.
`,
        img: require("@/assets/page26/Asset 258.png"),
      },
      Administration: {
        text: `Single dose of Tdap/Td every 10 years (IM). <br />
Tdap is preferred over Td.
`,
        img: require("@/assets/page26/Asset 259.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction 	
For Tdap only, history of encephalopathy not attributable to an identifiable cause, within 7d following DTP/DTaP, or Tdap`,
        img: require("@/assets/page26/Asset 260.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page25/Asset 246.png"),
    name: "yellowFever",
    ModalData: {
      Indications: {
        text: `Travelers aged ≥9 months who are traveling to or living in areas at risk for YF transmission in South America and Africa should be vaccinated. <br /> In addition, the International Health Regulations allow countries to require proof of YF vaccination as a condition of entry for travelers arriving from certain countries to prevent importation and indigenous transmission of YF virus. `,
        img: require("@/assets/page26/Asset 258.png"),
      },
      Administration: {
        text: `A single 0.5 mL subcutaneous injection. <br /> YF vаϲϲinе should be administered either simultaneously or 4 weeks apart from other live injectable viral vaccines.`,
        img: require("@/assets/page26/Asset 259.png"),
      },
      Contraindications: {
        text: `Because the YF is a live attenuated vaccine, it should not be given to individuals with primary immunodeficiencies, transplant recipients, patients on immunosuppressive and immunomodulatory therapies, or patients with HIV whose CD4 count is <200/mL. Other contraindications include age <6 months, allergy to a vaccine component, and thymic disorders. Precaution should be taken in infants aged six to eight months and in individuals ≥60 years of age. <br /> For travelers >60 years, the risk of severe illness and death due to yellow fever infection should be balanced against the risk of serious vaccine effects. <br /> Pregnancy is a precaution for yellow fever vaccine administration (in contrast with most other live vaccines that are contraindicated in pregnancy). <br />  If travel is unavoidable and the risks for yellow fever virus exposure are felt to outweigh the vaccination risks, a pregnant woman should be vaccinated. <br /> If the risks for vaccination are felt to outweigh the risks for yellow fever virus exposure, pregnant women should be issued a medical waiver to fulfill health regulations.`,
        img: require("@/assets/page26/Asset 260.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page25/Asset 256.png"),
    name: "HepatitisA",
    ModalData: {
      Indications: {
        text: `All adults seeking protection from (HAV) infection and persons with other risk factors.`,
        img: require("@/assets/page26/Asset 258.png"),
      },
      Administration: {
        text: "2 doses schedule with a minimum of 6 months interval",
        img: require("@/assets/page26/Asset 259.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction. </br>
        Precautions: 
Moderate or severe acute illness.`,
        img: require("@/assets/page26/Asset 260.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page25/Asset 257.png"),
    name: "HepatitisB",
    ModalData: {
      Indications: {
        text: "Recommended if some other risk factor is present (e.g., occupational, lifestyle, or other indications)",
        img: require("@/assets/page26/Asset 258.png"),
      },
      Administration: {
        text: `3-doses series at 0, 1 and 6 month intervals.`,
        img: require("@/assets/page26/Asset 259.png"),
      },
      Contraindications: {
        text: `Previous severe allergic reaction. </br>
        Precautions: 
                          Moderate or severe acute illness with or without fever`,
        img: require("@/assets/page26/Asset 260.png"),
      },
    },
  },
  {
    imgPath: require("@/assets/page25/Asset 245.png"),
    name: "MeningococcalMenB",
    ModalData: {
      Indications: {
        text: `<b> Indications for MenACWY and MenB :</b><br />
Anatomical or functional asplenia (including sickle cell disease and other hemoglobinopathies) <br />
Persistent complement component deficiency<br />
Eculizumab use <br />
Microbiologists routinely exposed to Neisseria meningitidis. <br />
At risk from a meningococcal disease outbreak <br />
<b>Indications for MenACWY:</b><br />
HIV infection<br />
Travel to or live in countries where meningococcal disease is hyperendemic or epidemic, including countries in the African meningitis belt or travel to Makkah, for the Umrah and Hajj<br />
Military recruits<br />
First-year college students<br />
`,
        img: require("@/assets/page26/Asset 258.png"),
      },
      Administration: {
        text: `<b>MenACWY:</b> Administer 1 dose and revaccinate with 1 dose of MenACWY every 5 years, if the risk remains. <br />
<b>MenB:</b> A 2-dose series, 6 months apart.
`,
        img: require("@/assets/page26/Asset 259.png"),
      },
      Contraindications: {
        text: `A severe allergic reaction (for example, anaphylaxis) to a vaccine component or to a prior dose
.`,
        img: require("@/assets/page26/Asset 260.png"),
      },
    },
  },
];
</script>
